/** Convert ISO / YYYY-MM-DD to DD-MM-YYYY for display */
export function toddmmyyyy(date: string): string {
  const ymd = date.split("T")[0];
  const [yyyy, mm, dd] = ymd.split("-");
  return `${dd}-${mm}-${yyyy}`;
}
